import React from "react";
import "./Shop_brands.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
function Shop_brands({ data }) {

    console.log(data,"data data brand");
    
  return (
    <>
      <section className="Shop_brands">
        <div className="container">
          <Common_Heading_Holder headingText={"Shop the Brands"} />
          <Swiper
            slidesPerView={6}
            spaceBetween={10}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: 1500 }}
            className="common_swiper"
            breakpoints={{
              0: {
                slidesPerView: 3,
              },
              600: {
                slidesPerView: 5,
              },

              1400: {
                slidesPerView: 6,
              },
            }}
          >
            {data?.map((val) => (
              <SwiperSlide>
                <div className="img_holder">
                  <img
                    src={process.env.REACT_APP_IMG_URL + val?.image}
                    alt=""
                    className="brand_img"
                  />
                </div>
              </SwiperSlide>
            ))}

          
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Shop_brands;
